import React, { useEffect, useState } from "react";
import { yellowStar } from "..";
import { FaYoutube } from "react-icons/fa";
import { RiFacebookBoxFill } from "react-icons/ri";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { BiLogoInstagramAlt } from "react-icons/bi";
import "../footerSection/footer.scss";
import Button from "../../assets/common/button/Button";
import { Link } from "react-router-dom";
import IntroForm from "../IntroForm/IntroForm";
import Aos from "aos";
import { Modal } from "antd";
import TermsandCondition from "../terms&ConditionComponent/TermsandCondition";
// import AOS from "aos";
// import "aos/dist/aos.css";

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [conditionModal, setConditionModal] = useState(false);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  //   useEffect(() => {
  //     AOS.init({ offset: 100 });
  //   }, []);

  const showModal = () => {
    setConditionModal(true);
  };

  const handleOk = () => {
    setConditionModal(false);
  };

  const handleCancel = () => {
    setConditionModal(false);
  };

  return (
    // <footer id="contact">
    //   <div className="footer-container">
    //     <div className="container">
    //       <div className="footer-content row">
    //         <div className="left col-md-8">
    //           <h2>
    //             CREATIVE DESIGN AGENCY
    //           </h2>
    //           <p>
    //             <a href="mailto:hello@brandcraftcreative.com">
    //               hello@brandcraftcreative.com |
    //             </a>{" "}
    //             <a href="tel:+919136097310"> MOB: +91 91360 97310</a>
    //           </p>
    //         </div>
    //         <div className="right col-md-4">
    //           <h4>ADDRESS</h4>
    //           <p>
    //             608/A, Pranik Chembers, Saki Vihar Road, Opposite HP Petrol Pump, Sakinaka Junction, Andheri East, Mumbai - 400072
    //           </p>
    //         </div>
    //       </div>

    //       <div className="footer-bottom row align-items-center mt-4">
    //         <div className="social-icons col-md-6 d-flex justify-content-start mb-3 mb-md-0">
    //           <ul>
    //             {/* <li>
    //               <a href="" target="_blan p-0 m-0k" className="social-icon">
    //                 <FaYoutube />
    //               </a>
    //             </li> */}
    //             <li>
    //               <a href="https://x.com/brand_craf59199" target="_blank" className="social-icon">
    //                 <FaTwitter />
    //               </a>
    //             </li>
    //             <li>
    //               <a href="https://www.linkedin.com/company/107005604/admin/dashboard/" target="_blank" className="social-icon">
    //                 <FaLinkedin />
    //               </a>
    //             </li>
    //             <li>
    //               <a href="https://www.instagram.com/brandcraftllp/" target="_blank" className="social-icon">
    //                 <BiLogoInstagramAlt />
    //               </a>
    //             </li>
    //             <li>
    //               <a href="https://www.facebook.com/profile.php?id=61574984356253" target="_blank" className="social-icon">
    //                 <RiFacebookBoxFill />
    //               </a>
    //             </li>
    //           </ul>
    //         </div>
    //         <div className="footer-bottom-content col-md-6 text-md-end">
    //           <p>© 2025 Brand Craft | All Rights Reserved</p>
    //         </div>
    //       </div>
    //     </div>
    //     {/* <img
    //       src={yellowStar}
    //       alt="start-Img"
    //       //   data-aos="zoom-in"
    //       //   data-aos-duration="1000"
    //       //   data-aos-easing="ease-in-out"
    //       className="footer-star"
    //     /> */}
    //   </div>
    // </footer>

    <footer id="contact">
      <div className="footer-section">
        <div className="container">
          <div className="footer-top">
            <div className="footer-left">
              <h4>Contact</h4>
              <p>
                <a href="mailto:hello@brandcraftcreative.com">
                  hello@brandcraftcreative.com
                </a>
              </p>
              <p>
                <a href="tel:+919136097310">MOB: +91 91360 97310</a>
              </p>
            </div>

            <div className="footer-center">
              <h3>Your project, our passion. Let’s team up.</h3>
              <Button
                className="project-button"
                onClick={() => setIsModalOpen(true)}
                text="DISCUSS YOUR PROJECT"
              />
            </div>
            <IntroForm
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
            />

            <div className="footer-right">
              <h4>Address</h4>
              <p>
                608/A, Pranik Chambers, Saki Vihar Road, Opposite HP Petrol
                Pump, Sakinaka Junction, Andheri East, Mumbai - 400072
              </p>
            </div>
          </div>

          <div className="footer-bottom">
            <p>© 2026 Brand Craft | All Rights Reserved</p>
            <p style={{ cursor: "pointer" }} onClick={showModal}>Terms & Conditions</p>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/profile.php?id=61574984356253"
                target="_blank"
              >
                <RiFacebookBoxFill />
              </a>
              <a
                href="https://www.instagram.com/brandcraftllp/"
                target="_blank"
              >
                <BiLogoInstagramAlt />
              </a>
              <a
                href="https://www.linkedin.com/company/107005604/admin/dashboard/"
                target="_blank"
              >
                <FaLinkedin />
              </a>
              <a href="https://x.com/brand_craf59199" target="_blank">
                <FaTwitter />
              </a>
            </div>
          </div>

          <p
            className="footer-title"
            data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom"
            data-aos-duration="500"
          >
            LET’S WORK TOGETHER
          </p>
        </div>
      </div>
      <Modal
        open={conditionModal}
        onOk={handleOk}
        onCancel={handleCancel}
        // footer={null} // remove footer buttons if you don’t want them
        width={900}
         bodyStyle={{
          maxHeight: "65vh",
          overflowY: "auto",
        }}
        maskClosable={false}
      getContainer={false}
      >
        <TermsandCondition />
      </Modal>
    </footer>
  );
};

export default Footer;
